import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas } from '../../styles';

export const Last10GamesContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['16b']}
    ${BaseStyle.Mixins.gaps.semiMedium}
    display: flex;
    flex-direction: column;
    grid-area: ${GameCenterComponentGridAreas.lastTenOrPlayoffsRecord};
    width: 100%;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 24px;
    }
`;
